import React, { FC, PropsWithChildren } from "react"

import { BoxProps } from "@mantine/core"
import { APIProvider, MapProps } from "@vis.gl/react-google-maps"

import GoogleMapsInner from "./GoogleMapsInner"
import { useLanguage } from "../../../contexts/language-context"

export type GoogleMapsProps = {
    options?: MapProps
    runWith?: (map: google.maps.Map) => void
    BoxProps?: BoxProps
}

const GoogleMaps: FC<PropsWithChildren<GoogleMapsProps>> = ({ children, ...props }) => {
    const { code } = useLanguage()

    return (
        <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY} language={code}>
            <GoogleMapsInner {...props}>{children}</GoogleMapsInner>
        </APIProvider>
    )
}

export default GoogleMaps
